<template>
	<v-col class="ma-0 pa-0" cols="12">
		<v-col v-if="item.streamAble == true" 
			@click="goVideoPlayer()" 
			class="thumbnail_box online ma-0 pa-0" cols="12" style="cursor: pointer;">
			<!-- <img v-if="item.thumbnail != undefined" style="height:100%;width:100%;" @load="onLoad(index)"
				class="ma-0 pa-0" :src="item.thumbnail" />
        
      <img v-if="item.thumbnail == undefined" style="height:100%;width:100%;" class="ma-0 pa-0" 
			src="@/assets/images/grey_background.png" @load="onLoad(index)"/>
      <v-col v-if="item.thumbnail == undefined" class="ma-0 pa-0" id="thumbnail_device_status">
        <v-col class="ma-0 pa-0">{{td('tempThumnailError')}}</v-col>
      </v-col> -->
			<img v-if="thumbnail != null" :key="thumbnailKey" style="height:100%;width:100%;" @load="onLoad(index)" @error="thumbnailError(index, $event)"
				class="ma-0 pa-0" :src="thumbnail" />
			<v-col v-if="streamingUrlLoading == false" class="ma-0 pa-0 pl-2"
				cols="12" id="thumbnail_title_box" align="left">
				{{ item.cameraName }}
			</v-col>
			<v-skeleton-loader id="img_skeleton" width='100%' height='100%' 
				:boilerplate="false" elevation="0" dark  type="image"
				v-if="imgLoaders[index] == true">
			</v-skeleton-loader>
			<v-skeleton-loader id="img_skeleton" width='100%' height='100%' 
				:boilerplate="false" elevation="0" dark  type="image"
				v-else-if="thumbnail === null">
			</v-skeleton-loader>
			<v-col v-if="thumbnail === null" class="ma-0 pa-0" id="thumbnail_device_status">
        <v-col class="ma-0 pa-0">{{td('fetchingThumbnail')}}</v-col>
      </v-col>
		</v-col>
		<v-col v-else 
			class="thumbnail_box ma-0 pa-0" cols="12" 
			style="cursor: pointer;" @click="noUrlGoVideoPlayer(index)">
			<img style="height:100%;width:100%;" class="ma-0 pa-0" 
				src="@/assets/images/grey_background.png" />
      <v-col class="ma-0 pa-0" id="thumbnail_device_status">
        <v-col class="ma-0 pa-0">{{t('offline')}}</v-col>
      </v-col>
		  <v-col class="ma-0 pa-0 pl-2" cols="12" id="thumbnail_title_box" align="left"
		  	v-if="streamingUrlLoading == false">{{ item.cameraName }}</v-col>
    </v-col>
	</v-col>
</template>

<script>
import { THUMBNAIL_REFRESH_INTERVAL, THUMBNAIL_KVS_REFRESH_INTERVAL } from '@/constants';
import mixin from '@/mixin';
import AWS from 'aws-sdk';
export default {
	props: {
		item: { type: Object },
		index: { type: Number },
		imgLoaders: { type: Array },
		streamingUrlLoading: { type: Boolean },
	},
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
		deviceStatusList: ['5', '10', '12', '17', '19', '20'],
		unisCustomerCd: '',
    storeData: {},
		// 처음에는 loader로 띄우고 KVS에서 thumbnail가져오면 업데이트, 실패시 item.thumbnail 보여주도록 수정
		thumbnail: null,
		thumbnailKey: 0, // Key 값을 추가하여 강제 렌더링
		getKvsThumbnailTimer: null,
		getThumbnailTimer: null,
	}),
	filters: {
		statusFormat: function(str) {
			if(str != undefined) {
				return str.length > 20 ? str.substring(0,20) + '...' : str;
			} else {
				return '';
			}
		},
	},
	mounted() {
		if(this.$route.name == 'storeCCTV') {
			this.unisCustomerCd = this.$route.query.unisCustomerCd;
    	this.storeData = this.$store.getters.getStoreData;
		}
		
		// AWS.config.region = process; // Region
    // AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    //   IdentityPoolId: 'ap-southeast-1:c555a718-3032-4135-bad7-5e3d888c8605',
    //   RoleArn: 'arn:aws:iam::509004160589:role/Cognito_UeyesStgPoolUnauth_Role'
    // });
		if (this.item.streamAble == true) {
			if (this.$store.state.isMobile) {
				this.thumbnail = this.item.thumbnail;
				this.getKvsThumbnailTimer = null;
			} else {
				console.log(this.item);
				if (this.item.kvs && this.item.kvs.streaming) {
					this.getKvsThumbnail();
					this.getKvsThumbnailTimer = setInterval(this.getKvsThumbnail, THUMBNAIL_KVS_REFRESH_INTERVAL);
				} else {
					this.requestUpdateThumbnail();
					this.getThumbnailTimer = setInterval(this.requestUpdateThumbnail, THUMBNAIL_REFRESH_INTERVAL);
				}
			}
		}
	},
	methods: {
    td(t) {
      return this.$t("lang.dashboard." + t);
    },
		onLoad(index) {
			this.$emit('onLoad', {
				index, value: false
			})
		},
		checkRoute() {
			if(this.$route.path.includes('dashboard') || this.$route.path.includes('private')) {
				this.$store.commit('setPlayerFromWhere', { from: 'dashboard', name: 'dashboard' });
			} else {
				if(this.$route.query.groupId) { // 점포그룹
					this.$store.commit('setPlayerFromWhere', { from: 'group', name: 'group' });
				} else { // 점포검색
					this.$store.commit('setPlayerFromWhere', { from: 'search', name: 'search' });
				}
			}
		},
		async goVideoPlayer() {
			this.$vloading.show();
			this.checkRoute();
			await this.$store.commit('setStreamInfo', this.item);
			this.$vloading.hide();
			if(this.$route.name === 'storeCCTV') {
				if(this.$route.query.groupId) { // 점포그룹
					this.pushRoute('/video-player', {
						unisCustomerCd: this.unisCustomerCd,
						customerName: this.storeData.customerName,
						groupId: this.$route.query.groupId
					});
				} else {
					this.pushRoute('/video-player', {
						unisCustomerCd: this.unisCustomerCd,
						customerName: this.storeData.customerName
					});
				}
			} else {
				this.prevRouterCheck();
				this.pushRoute('/video-player', {});
			}
    },
		async noUrlGoVideoPlayer() {
			this.checkRoute();
			await this.$store.commit('setVideoStreamingUrl', '');
      await this.$store.commit('setStreamInfo', this.item);
      if(this.$route.name === 'storeCCTV') {
        if(this.$route.query.groupId) { // 점포그룹
          this.pushRoute('/video-player', {
            unisCustomerCd: this.unisCustomerCd,
            customerName: this.storeData.customerName,
            groupId: this.$route.query.groupId
          });
        } else {
          this.pushRoute('/video-player', {
            unisCustomerCd: this.unisCustomerCd,
            customerName: this.storeData.customerName
          });
        }
      } else {
        this.prevRouterCheck();
        this.pushRoute('/video-player', {});
      }
		},
		prevRouterCheck() {
			if(this.$route.path.includes('dashboard')) {
				sessionStorage.setItem('prevRoute', JSON.stringify({
					name: 'dashboard', path: '/dashboard'
				}));
			} else {
				sessionStorage.setItem('prevRoute', JSON.stringify({
					name: 'privateStoreCCTV', path: '/private/store-cctv'
				}));
			}
		},
		async getKvsThumbnail() {
			try {
				if (this.item.kvs && this.item.kvs.streaming) {
					const kvsGetImageResult = await this.networkController.awsGetThumbnail(this.item.streamName);
					if (kvsGetImageResult) {
						this.thumbnail = "data:image/png;base64," + kvsGetImageResult.ImageContent;
					}
				}
			} catch (error) {
				// 에러의 대표 text와 item의 information을 출력하자
				console.info(error.message, this.item.cameraName);
				// 오류 발생시 1분 전 취득한 thumbnail이 있다면 활용, 없으면 S3의 것 가져옴.
				if (this.thumbnail === null)
					this.thumbnail = this.item.thumbnail;
			}
		},
		async requestUpdateThumbnail() {
			const { contractCd, portNo } = this.item;
			try {
				await this.networkController.updateCameraThumbnail({}, contractCd, portNo);
				// 요청 후 5초 뒤에 썸네일 가져옴
				setTimeout(async () => {
					this.thumbnail = await this.getThumbnail();
					this.thumbnailKey += 1; // Key 값을 변경하여 강제 렌더링
				}, 3000);
				this.thumbnailKey += 1; // Key 값을 변경하여 강제 렌더링
			} catch (error) {
				console.info(error.message, this.item.cameraName);
				this.thumbnail = this.item.thumbnail;
				this.thumbnailKey += 1; // Key 값을 변경하여 강제 렌더링
			}
		},
		async getThumbnail() {
			const { contractCd, portNo } = this.item;
			let res = null;
			try {
				res = await this.networkController.getCameraThumbnail({}, contractCd, portNo);
			} catch (error) {
				console.info(error.message, this.item.cameraName);
				return this.item.thumbnail;
			}
			return res.data;
		},
    thumbnailError(index, event) {
      this.$emit('onLoad', {
				index, value: false
			});
      event.target.style.display = 'none';
      const errorMsg = document.createElement('div');
      errorMsg.innerText = 'サムネイル・エラー';
      const errorBox = document.createElement('div');
      errorBox.classList.add('ma-0', 'pa-0');
      errorBox.style.backgroundColor = 'rgb(69, 69, 69)';
      errorBox.style.height = '100%';
      errorBox.style.alignContent = 'center';
      errorBox.appendChild(errorMsg);
      event.target.parentElement.appendChild(errorBox);
    }
	},
	beforeDestroy() {
		if (this.getKvsThumbnailTimer) clearInterval(this.getKvsThumbnailTimer);
		if (this.getThumbnailTimer) clearInterval(this.getThumbnailTimer);
	}
}
</script>

<style lang="scss" scoped>
.thumbnail_box {
	position: relative;
	height: 13rem;
}
.online {
	transition: transform .2s;
	&:hover {
		transform: scale(1.07);
		z-index: 3;
	}
}
#thumbnail_title_box {
	/**
	 white-space: nowrap을 통해 줄바꿈을 방지하고,
	 overflow: hidden을 통해 텍스트가 넘치는 부분을 감추며,
	 text-overflow: ellipsis를 통해 넘치는 부분에 ... 표시를 추가하여
	 텍스트가 넘치는 부분을 간결하게 표현
	 */
	white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
	position: absolute;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.75);
	color: #BEBEBE;
	font-size: 0.8rem;
}
#img_skeleton {
	position: absolute;
	top: 0;
}
#thumbnail_device_status {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -55%);
}
</style>